export default "__VITE_ASSET__DutlzrW7__"